import * as React from 'react';
import { createIllustration } from '@balance-web/illustration';

import { describeWithOptions } from './describeWithOptions';

export const ReckonInsightsLogoName = 'ReckonInsights';
export const ReckonInsightsLogoDescription = 'Reckon Insights Application Logo';

export const ReckonInsightsLogo = createIllustration(
  describeWithOptions(
    ReckonInsightsLogoName,
    ReckonInsightsLogoDescription,
    60,
    60
  ),
  <React.Fragment>
    <mask
      height="60"
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      width="60"
      x="0"
      y="0"
    >
      <path
        d="M0 14C0 6.26801 6.26801 0 14 0H46C53.732 0 60 6.26801 60 14V46C60 53.732 53.732 60 46 60H14C6.26801 60 0 53.732 0 46V14Z"
        fill="url(#paint0_linear)"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect fill="url(#paint1_linear)" height="60" width="60" />
      <g clipPath="url(#clip0)">
        <path
          clipRule="evenodd"
          d="M36.6667 18.6667C35.9303 18.6667 35.3333 19.2636 35.3333 20C35.3333 20.7364 35.9303 21.3333 36.6667 21.3333H41.4477L31.9999 30.781L26.2761 25.0572C25.7554 24.5365 24.9112 24.5365 24.3905 25.0572L14.3905 35.0572C13.8698 35.5779 13.8698 36.4221 14.3905 36.9428C14.9112 37.4635 15.7554 37.4635 16.2761 36.9428L25.3333 27.8856L31.0571 33.6095C31.5778 34.1302 32.422 34.1302 32.9427 33.6095L43.3333 23.2189V28C43.3333 28.7364 43.9303 29.3333 44.6667 29.3333C45.403 29.3333 46 28.7364 46 28V20C46 19.7986 45.9553 19.6077 45.8754 19.4365C45.8245 19.3272 45.758 19.2235 45.6758 19.1285C45.6351 19.0814 45.5911 19.0372 45.5442 18.9961C45.4388 18.9038 45.3223 18.8309 45.1994 18.7774C45.0363 18.7062 44.8561 18.6667 44.6667 18.6667H36.6667Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
      <g filter="url(#filter0_b)">
        <path d="M60 19L19 60H60V19Z" fill="white" fillOpacity="0.2" />
      </g>
      <path
        clipRule="evenodd"
        d="M41.3615 43.8148V53.5497H51.1C52.4091 53.5497 53.4741 52.4846 53.4741 51.1767V43.8148C53.4741 42.5069 52.4091 41.4417 51.1 41.4417H43.7356C42.4265 41.4417 41.3615 42.5069 41.3615 43.8148ZM40.3615 54.5497H51.1C52.9611 54.5497 54.4741 53.0372 54.4741 51.1767V43.8148C54.4741 41.9543 52.9611 40.4417 51.1 40.4417H43.7356C41.8745 40.4417 40.3615 41.9543 40.3615 43.8148V54.5497Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        d="M44.566 43.7211H47.9268C48.8774 43.7211 49.6139 44.0022 50.0959 44.4707C50.4976 44.8856 50.7252 45.4344 50.7252 46.0903V46.1171C50.7252 47.3485 49.9888 48.0981 48.9444 48.3926L50.9796 51.2436H49.3996L47.5519 48.6201H45.8916V51.2436H44.566V43.7211ZM47.8331 47.4556C48.7837 47.4556 49.3863 46.9604 49.3863 46.1974V46.1706C49.3863 45.3675 48.8105 44.9258 47.8197 44.9258H45.8916V47.4556H47.8331Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="57"
        id="filter0_b"
        width="57"
        x="11"
        y="11"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation="4" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur"
          mode="normal"
          result="shape"
        />
      </filter>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear"
        x1="0"
        x2="62.0988"
        y1="0"
        y2="57.7428"
      >
        <stop stopColor="#F88B00" />
        <stop offset="1" stopColor="#FFB027" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear"
        x1="0"
        x2="62.0988"
        y1="0"
        y2="57.7428"
      >
        <stop stopColor="#F88B00" />
        <stop offset="1" stopColor="#FFB027" />
      </linearGradient>
      <clipPath id="clip0">
        <rect
          fill="white"
          height="32"
          transform="translate(14 12)"
          width="32"
        />
      </clipPath>
    </defs>
  </React.Fragment>
);
